import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { useOBMutation } from './useOBMutation';
export interface DeleteHourSlotRequest {
  reservationId: string;
}

const useDeleteHourSlots = ({ reservationId }: DeleteHourSlotRequest) => {
  const url = useApiUrl(
    OBRoutes.ReservationDeletion,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##reservationId', reservationId);

  return useOBMutation<any, string>(url || '', {
    method: 'DELETE',
  });
};

export default useDeleteHourSlots;
